interface HeroProps {
    readonly onCreateClick: () => void;
}

export function Hero({ onCreateClick }: HeroProps) {

    return (
        <section className="hero">
            <div className="hero__badges">
                <div className="hero__badge">
                    <span className="hero__badge-dot" />
                    Live on Bitcoin L1
                </div>
                <div className="hero__badge hero__badge--muted">
                    Powered by OPNet
                </div>
            </div>

            <h1 className="hero__headline">
                Fund the Future
                <br />
                on <span className="hero__headline-accent">Bitcoin</span>
            </h1>

            <p className="hero__sub">
                The first crowdfunding platform built natively on Bitcoin Layer 1. No bridges, no
                wrapping, no middlemen. Create a campaign or fund one that matters.
            </p>

            <div className="hero__actions">
                <button className="btn btn--primary btn--lg" onClick={onCreateClick}>
                    + Create Campaign
                </button>
                <a href="#campaigns" className="btn btn--secondary btn--lg">
                    Browse Campaigns
                </a>
            </div>

            <div className="hero__scroll">
                <span>Scroll to explore</span>
                <div className="hero__scroll-line" />
            </div>
        </section>
    );
}
